/**
 * Alias de lecture sur les types générés depuis le contrat.
 *
 * `schema.d.ts` est produit par `npm run types:api` depuis `docs/openapi.json`, lui-même généré
 * depuis les modèles Pydantic du backend. Aucun type d'entité n'est écrit à la main ici : ce fichier
 * ne fait que donner des noms courts à des chemins profonds du schéma.
 *
 * Conséquence à garder en tête : ajouter un champ côté backend le fait apparaître ici après
 * régénération, et le compilateur signale les endroits à mettre à jour. C'est tout l'intérêt
 * (`docs/DECISIONS.md` D46).
 */
import type { components } from "./schema";

type Schemas = components["schemas"];

export type FicheGrv = Schemas["FicheGrv"];
export type ValeurReferentielActive = Schemas["ValeurReferentielActive"];
export type Position = Schemas["Position"];
export type Mouvement = Schemas["Mouvement"];
export type Geozone = Schemas["GeozonePubliee"];
export type EvenementFicheDeVie = Schemas["EvenementFicheDeVie"];
export type LigneMaintenanceTransversale = Schemas["LigneMaintenanceTransversale"];
export type TypeEvenement = Schemas["TypeEvenement"];
export type Tracker = Schemas["Tracker"];
export type ChecklistEnregistree = Schemas["ChecklistEnregistree"];
export type Document = Schemas["DocumentPublie"];
export type Alerte = Schemas["Alerte"];
export type Indicateur = Schemas["Indicateur"];
export type TableauDeBord = Schemas["TableauDeBord"];
export type Rapport = Schemas["Rapport"];

export type ValeurReferentiel = Schemas["ValeurReferentiel"];
export type ValeurReferentielPubliee = Schemas["ValeurReferentielPubliee"];
export type SeuilPublie = Schemas["SeuilPublie"];
export type MiseAJourSeuil = Schemas["MiseAJourSeuil"];
export type RegleAlertePubliee = Schemas["RegleAlertePubliee"];
export type MiseAJourRegleAlerte = Schemas["MiseAJourRegleAlerte"];
export type ModeleExportPublie = Schemas["ModeleExportPublie"];
export type MiseAJourModeleExport = Schemas["MiseAJourModeleExport"];
export type CreationModeleExport = Schemas["CreationModeleExport"];
export type SourceExportPubliee = Schemas["SourceExportPubliee"];
export type ColonneDisponible = Schemas["ColonneDisponible"];
export type ModeleExportSelectionnable = Schemas["ModeleExportSelectionnable"];
export type UtilisateurCompte = Schemas["UtilisateurCompte"];
export type CreationUtilisateur = Schemas["CreationUtilisateur"];
export type MiseAJourUtilisateur = Schemas["MiseAJourUtilisateur"];
export type EntreeAudit = Schemas["EntreeAudit"];

export type MiseAJourGrv = Schemas["MiseAJourGrv"];
export type AssociationTracker = Schemas["AssociationTracker"];
export type ChangementStatut = Schemas["ChangementStatut"];
export type Intervention = Schemas["Intervention"];
export type MiseAJourEvenement = Schemas["MiseAJourEvenement"];
export type EnregistrementChecklist = Schemas["EnregistrementChecklist"];
export type QuestionChecklist = Schemas["QuestionChecklist"];
export type ReponseChecklist = Schemas["ReponseChecklist"];
export type DefinitionGeozone = Schemas["DefinitionGeozone"];
export type DemandeDepot = Schemas["DemandeDepot"];
export type DemandeRapport = Schemas["DemandeRapport"];
export type ActionSurAlerte = Schemas["ActionSurAlerte"];

/** Les quatre groupes Cognito. Éléments **fixés** du projet, jamais dérivés d'autre chose. */
export const PROFILS = [
  "admin-totalenergies",
  "operationnel-totalenergies",
  "air-tahiti",
  "support",
] as const;

export type Profil = (typeof PROFILS)[number];

/** Pagination renvoyée dans `meta` sur les routes de liste. */
export type Pagination = { pageSize?: number; cursor?: string | null };
